import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
  name: 'lyceoDateFormat',
})
export class DateFormatPipe implements PipeTransform {
  public transform(
    date: string | number | Date | null,
    formatStr: string,
  ): string {
    if (!date) {
      return '';
    }

    return format(date, formatStr);
  }
}
